import { render, staticRenderFns } from "./noticebook.vue?vue&type=template&id=4fe234fc&scoped=true&"
import script from "./noticebook.vue?vue&type=script&lang=js&"
export * from "./noticebook.vue?vue&type=script&lang=js&"
import style0 from "./noticebook.vue?vue&type=style&index=0&id=4fe234fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe234fc",
  null
  
)

export default component.exports